'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _dateTimeHelper = require('./dateTimeHelper');

var _dateTimeHelper2 = _interopRequireDefault(_dateTimeHelper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var DatetimepickerController = function () {
    _createClass(DatetimepickerController, null, [{
        key: '$inject',
        get: function get() {
            return ['$element'];
        }
    }]);

    function DatetimepickerController($element) {
        var _this = this;

        _classCallCheck(this, DatetimepickerController);

        this.$element = $element;
        this.$element.on('dp.change', function (e) {
            _this.onValueChanged(e);
        });
    }

    _createClass(DatetimepickerController, [{
        key: 'format',
        get: function get() {
            return this.$element.datetimepicker('format');
        },
        set: function set(value) {
            this.$element.datetimepicker('format', _dateTimeHelper2.default.getMomentFormat(value));
        }
    }, {
        key: 'datetime',
        get: function get() {
            return this.$element.datetimepicker('parseInputDate');
        },
        set: function set(value) {
            // Allow this?
            this.$element.datetimepicker('parseInputDate', value);
        }
    }, {
        key: 'onValueChanged',
        get: function get() {
            return this._onValueChanged || function () {};
        },
        set: function set(value) {
            if (typeof value === 'function') {
                this._onValueChanged = value;
            }
        }
    }]);

    return DatetimepickerController;
}();

exports.default = DatetimepickerController;


//////////////////
// WEBPACK FOOTER
// ./common/directives/datepicker/datetimepicker.controller.js
// module id = 708
// module chunks = 0